import QuoteSection from "@/components/QuoteSection";

export default function Quote() {
  return (
    <div className="pt-16">
      <QuoteSection />
    </div>
  );
}